import { Plus, Trash2 } from "lucide-react";

const blank = (fee_id = "") => ({ name: "", age: "", fee_id, notes: "" });

export default function MembersEditor({ members, onChange, fees }) {
  const personFees = fees.filter((f) => f.per !== "family");
  const update = (i, k, v) => onChange(members.map((m, j) => (j === i ? { ...m, [k]: v } : m)));
  return (
    <div className="space-y-4">
      {members.map((m, i) => (
        <div key={m.id || i} data-testid={`member-row-${i}`} className="rounded-2xl border-2 border-amber-900/10 bg-[#FDF6ED]/60 p-4 sm:p-5">
          <div className="flex items-center justify-between mb-3">
            <p className="font-heading text-lg font-semibold">Person {i + 1}</p>
            {members.length > 1 && (
              <button type="button" data-testid={`member-remove-${i}`} onClick={() => onChange(members.filter((_, j) => j !== i))} className="btn-danger !min-h-[40px] !px-4">
                <Trash2 className="w-4 h-4" />Remove
              </button>
            )}
          </div>
          <div className="grid sm:grid-cols-6 gap-3">
            <input data-testid={`member-name-input-${i}`} className="field sm:col-span-3" placeholder="Full name" value={m.name} onChange={(e) => update(i, "name", e.target.value)} />
            <input data-testid={`member-age-input-${i}`} className="field sm:col-span-1" placeholder="Age" inputMode="numeric" value={m.age || ""} onChange={(e) => update(i, "age", e.target.value)} />
            {personFees.length > 0 && (
              <select data-testid={`member-fee-select-${i}`} className="field sm:col-span-2" value={m.fee_id || ""} onChange={(e) => update(i, "fee_id", e.target.value)}>
                <option value="">Fee type…</option>
                {personFees.map((f) => <option key={f.id} value={f.id}>{`${f.label} (${f.tbd ? "TBD" : Number(f.amount) ? `$${Number(f.amount).toFixed(0)}` : "free"})`}</option>)}
              </select>
            )}
            <input data-testid={`member-notes-input-${i}`} className="field sm:col-span-6" placeholder="Notes (food allergies, needs, shirt size…)" value={m.notes || ""} onChange={(e) => update(i, "notes", e.target.value)} />
          </div>
        </div>
      ))}
      <button type="button" data-testid="member-add-button" onClick={() => onChange([...members, blank(personFees[0]?.id || "")])} className="btn-outline w-full sm:w-auto">
        <Plus className="w-5 h-5" />Add another person
      </button>
    </div>
  );
}

export { blank as blankMember };
